export function declOfNum (number, titles) {
  const cases = [2, 0, 1, 1, 1, 2]
  return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]]
}

export function getMainDomain (link) {
  return link.split('.').slice(-2).join('.')
}

export function getValue (object, value, defaultValue = null) {
  let result = defaultValue

  if (typeof value === 'undefined') {
    return result
  }

  function isObject (value) {
    return value && typeof (value) === 'object'
  }

  if (!isObject(object)) {
    return result
  }

  const innerGetValue = (object, value) => {
    if (!isObject(object)) {
      return null
    }

    return object[value] || null
  }

  const keys = value.split('.')

  result = object

  for (const i in keys) {
    // eslint-disable-next-line no-prototype-builtins
    if (keys.hasOwnProperty(i)) {
      result = innerGetValue(result, keys[i])

      if (result === null) {
        result = defaultValue
        break
      }
    }
  }

  return result
}

export function forEach (listItems, callback) {
  for (const key in listItems) {
    // eslint-disable-next-line no-prototype-builtins
    if (listItems.hasOwnProperty(key)) {

      if (callback(listItems[key], key) === false) {
        break
      }
    }
  }
}

export function isObject (value) {
  return value !== null && typeof value === 'object'
}

export function isFunction (value) {
  return typeof value === 'function'
}

export function isNil (value) {
  return typeof value === 'undefined' || value === null
}

export function isEmpty (value) {
  if (typeof value === 'string') {
    return String(value).trim().length === 0
  }

  return isNil(value)
}

/*
 * сортировка
 * extractor - название колонки (если это массив объектов)
 * reverse - default=false сортировать в обратном порядке
 * */
export function sort (array, extractor, reverse) {

  if (!Array.isArray(array)) {
    return array
  }

  extractor = extractor || null
  reverse = reverse || false

  const sort = (sArray, sReverse) => {
    let data = sArray.slice().sort((a, b) => a - b)

    if (sReverse) {
      data = data.reverse()
    }

    return data
  }

  const sortWithExtractor = (eArray, element, eReverse) => {

    let data = eArray.slice().sort((i, ii) => {

      if (i[element] > ii[element]) {
        return 1
      } else if (i[element] < ii[element]) {
        return -1
      }

      return 0
    })

    if (eReverse) {
      data = data.reverse()
    }

    return data
  }

  if (extractor) {
    return sortWithExtractor(array, extractor, reverse)
  }

  return sort(array, reverse)
}

/*
 * сортировка
 * extractor - название колонки (если это массив объектов)
 * reverse - default=false сортировать в обратном порядке
 * */
export function sortByString (items, extractor, reverse = false) {
  return items.sort((a, b) => {
    return reverse ? b[extractor].localeCompare(a[extractor]) : a[extractor].localeCompare(b[extractor])
  })
}

/**
 * Синхронный враппер try/catch
 *
 * @param {Function} func
 * @param {Function} errorHandler
 * @returns
 */
export const tryWrapper = (func, errorHandler = () => {}) => {
  let res
  try {
    res = func()
  } catch (e) {
    errorHandler(e)
  }
  return res
}

/**
 * pick object
 * @param {Object} obj
 * @param {Array|String} props
 */
 export function pick (obj, props) {
  if (!isObject(obj)) return {}

  if (!Array.isArray(props)) {
    props = [props]
  }

  const res = {}
  props.forEach(prop => {
    if (prop in obj) {
      res[prop] = obj[prop]
    }
  })

  return res
}
